import { Link } from '#app/components/Link/index.js';
import { CategoryTagContainer, TagLabel } from './CategoryTag.styles.js';
import { getCategoryHref } from './util.js';
import { forwardRef, type Ref } from 'react';

type CategoryTagProps = {
  readonly asLink?: boolean;
  readonly displayUsername: string;
  readonly highlighted?: boolean;
  readonly id: string;
  readonly label: string;
  readonly onClickTag?: () => void;
  readonly size: 'large' | 'small';
};

export const CategoryTag = forwardRef(
  (
    {
      asLink = false,
      displayUsername,
      highlighted = false,
      id,
      label,
      size = 'large',
      ...props
    }: CategoryTagProps,
    ref: Ref<HTMLDivElement>,
  ) => {
    const tag = (
      <CategoryTagContainer
        $highlighted={highlighted}
        $id={id}
        $label={label}
        $size={size}
        ref={ref}
        {...props}
      >
        <TagLabel
          $id={id}
          $label={label}
          $size={size}
        >
          {label}
        </TagLabel>
      </CategoryTagContainer>
    );

    return asLink ? (
      <Link to={getCategoryHref({ displayUsername, id, name: label })}>
        {tag}
      </Link>
    ) : (
      tag
    );
  },
);
